import config from '../config.json';
import { DashboardConfig } from '../models/urlConfig';

export interface PreviewEnvironment {
	number: number;
}

interface PreviewEnvironmentResponse {
	previews: PreviewEnvironment[];
}

const previewStorageKey = 'previewNumber';
const dashboardConfig = config as DashboardConfig;
const previewListUrl = process.env.REACT_APP_PREVIEW_LIST_URL || dashboardConfig.preview.listUrl;

export const getAvailablePreviewEnvironments = async (): Promise<PreviewEnvironment[]> => {
	const response = await fetch(previewListUrl, { cache: 'no-store' });

	if (!response.ok) {
		throw new Error('Impossible de récupérer les PR Preview.');
	}

	const data = (await response.json()) as PreviewEnvironmentResponse;
	if (!Array.isArray(data.previews)) {
		throw new Error('La liste des PR Preview est invalide.');
	}

	return data.previews
		.filter((preview) => Number.isInteger(preview.number) && preview.number > 0)
		.sort((left, right) => right.number - left.number);
};

export const getPreviewBaseUrl = (previewNumber: number): string => {
	if (!Number.isInteger(previewNumber) || previewNumber <= 0) {
		throw new Error('Le numéro de PR Preview est invalide.');
	}

	return dashboardConfig.preview.baseUrlTemplate.replace('{number}', previewNumber.toString());
};

export const getPreviewApiUrl = (previewNumber: number): string => `${getPreviewBaseUrl(previewNumber)}/phm-api`;

export const getPreviewPrimCoreApiUrl = (previewNumber: number): string => `${getPreviewBaseUrl(previewNumber)}/primcore-api`;

export const getStoredPreviewNumber = (): number | null => {
	const storedValue = localStorage.getItem(previewStorageKey);
	if (!storedValue) return null;

	const previewNumber = Number(storedValue);
	return Number.isInteger(previewNumber) && previewNumber > 0 ? previewNumber : null;
};

export const setStoredPreviewNumber = (previewNumber: number | null): void => {
	if (previewNumber === null) {
		localStorage.removeItem(previewStorageKey);
		return;
	}

	localStorage.setItem(previewStorageKey, previewNumber.toString());
};
